import { createAction, props } from '@ngrx/store';

export const setOrganisationId = createAction(
  '[Organisation] Set Organisation Id',
  props<{ organisation_id: string }>()
);

export const clearOrganisationId = createAction(
  '[Organisation] Clear Organisation Id'
);

export const setUIContext = createAction(
  '[UI Context] Set',
  props<{ currentFlow: 'standalone' | 'overview-popup' }>()
);

export const clearUIContext = createAction('[UI Context] Clear');